import React from "react";
import Header from "../Header";

function Policy() {
  return (
    <div className="Policy">
      <div>
        <Header />

        <div id="main_contents_wrap">
          <div className="common_contents_inner">
            <h2>개인정보 처리방침</h2>
            <section>
              <p className="notice">
                kemiez ('https://hoonitang.github.io/react-app-site/'이하
                'kemiez')은(는) 「개인정보 보호법」 제30조에 따라 정보주체의
                개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할
                수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을
                수립·공개합니다. ○ 이 개인정보처리방침은 2022년 3월 5부터
                적용됩니다.
              </p>
              <article>
                <h3>제1조(개인정보의 처리 목적)</h3>
                <p>
                  ('https://hoonitang.github.io/react-app-site/'이하
                  'kemiez')은(는) 다음의 목적을 위하여 개인정보를 처리합니다.
                  처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지
                  않으며 이용 목적이 변경되는 경우에는 「개인정보 보호법」
                  제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할
                  예정입니다. 개인정보를 보유 하지 않습니다.
                </p>
              </article>
              <article>
                <h3>제2조(개인정보의 처리 및 보유 기간)</h3>
                <p>
                  ① kemiez 은(는) 법령에 따른 개인정보 보유·이용기간 또는
                  정보주체로부터 개인정보를 수집 시에 동의받은 개인정보
                  보유·이용기간 내에서 개인정보를 처리·보유합니다. ② 개인정보를
                  보유 하지 않습니다. 보유기간이 없습니다.
                </p>
              </article>
              <article>
                <h3>제3조(개인정보의 제3자 제공)</h3>
                <p>
                  ① kemiez 은(는) 개인정보를 제1조(개인정보의 처리 목적)에서
                  명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한
                  규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는
                  경우에만 개인정보를 제3자에게 제공합니다. ② kemiez 은(는)
                  개인정보를 제3자에게 제공하고 있지않습니다.
                </p>
              </article>
              <article>
                <h3>제4조(개인정보처리 위탁)</h3>
                <p>kemiez 개인정보를 위탁하고 있지않습니다.</p>
              </article>
              <article>
                <h3>제5조(정보주체와 법정대리인의 권리·의무 및 그 행사방법)</h3>
                <p>
                  ① 정보주체는 kemiez에 대해 언제든지 개인정보
                  열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.
                  <br />
                  ② 제1항에 따른 권리 행사는kemiez에 대해 「개인정보 보호법」
                  시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을
                  통하여 하실 수 있으며 kemiez은(는) 이에 대해 지체 없이
                  조치하겠습니다.
                  <br />
                  ③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을
                  받은 자 등 대리인을 통하여 하실 수 있습니다.이 경우 “개인정보
                  처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른
                  위임장을 제출하셔야 합니다.
                  <br />
                  ④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조
                  제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수
                  있습니다.
                  <br />
                  ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가
                  수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수
                  없습니다.
                  <br />
                  ⑥ kemiez은(는) 정보주체 권리에 따른 열람의 요구, 정정·삭제의
                  요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나
                  정당한 대리인인지를 확인합니다.
                  <br />
                  kemiez 개인정보를 저장하거나 위탁하지 않습니다.
                </p>
              </article>
              <article>
                <h3>제6조(처리하는 개인정보의 항목 작성)</h3>
                <p>① kemiez 은(는) 개인정보 항목을 처리하지 않습니다.</p>
              </article>
              <article>
                <h3>제7조(개인정보의 파기)</h3>
                <p>
                  ① kemiez 은(는) 개인정보 보유기간의 경과, 처리목적 달성 등
                  개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를
                  파기합니다.
                  <br />
                  ① 개인정보 파기의 절차 및 방법은 다음과 같습니다.
                  <br />
                  kemiez 은(는) 파기 사유가 발생한 개인정보를 선정하고, kemiez
                  의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
                  <br />
                  kemiez 개인정보를 보유 하지 않습니다.
                </p>
              </article>

              <article>
                <h3>제8조(개인정보의 안전성 확보 조치)</h3>
                <p>
                  kemiez 은(는) 개인정보의 안전성 확보를 위해 다음과 같은 조치를
                  취하고 있습니다.
                  <br />
                  ① 개인정보 파기의 절차 및 방법은 다음과 같습니다.
                  <br />
                  1. 개인정보에 대한 접근 제한
                  <br />
                  개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의
                  부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여
                  필요한 조치를 하고 있으며 침입차단시스템을 이용하여
                  외부로부터의 무단 접근을 통제하고 있습니다.
                </p>
              </article>

              <article>
                <h3>
                  제9조(개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항)
                </h3>
                <p>
                  kemiez 은(는) 정보주체의 이용정보를 저장하고 수시로 불러오는
                  ‘쿠키(cookie)’를 사용하지 않습니다.
                  <br />
                </p>
              </article>

              <article>
                <h3>제10조 (개인정보 보호책임자)</h3>
                <p>
                  ① kemiez 은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고,
                  개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을
                  위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                  <br />
                  ▶ 개인정보 보호책임자 성명 :김태훈 직책 :대표 직급 :대표
                  연락처 :01062334925, vinieo0000@gmail.com,
                  <br />
                  ※ 개인정보 보호 담당부서로 연결됩니다.
                  <br />▶ 개인정보 보호 담당부서 부서명 :김태훈 담당자 :김태훈
                  연락처 :01062334925, vinieo0000@gmail.com
                  <br />② 정보주체께서는 kemiez 의 서비스(또는 사업)을
                  이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리,
                  피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로
                  문의하실 수 있습니다. kemiez 은(는) 정보주체의 문의에 대해
                  지체 없이 답변 및 처리해드릴 것입니다.
                </p>
              </article>

              <article>
                <h3>제11조(권익침해 구제방법)</h3>
                <p>
                  정보주체는 개인정보침해로 인한 구제를 받기 위하여
                  개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터
                  등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타
                  개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기
                  바랍니다. 1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972
                  (www.kopico.go.kr) 2. 개인정보침해신고센터 : (국번없이) 118
                  (privacy.kisa.or.kr) 3. 대검찰청 : (국번없이) 1301
                  (www.spo.go.kr) 4. 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)
                  「개인정보보호법」제35조(개인정보의 열람), 제36조(개인정보의
                  정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한
                  요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여
                  권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에
                  따라 행정심판을 청구할 수 있습니다. ※ 행정심판에 대해 자세한
                  사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를
                  참고하시기 바랍니다.
                </p>
              </article>

              <article>
                <h3>제12조(개인정보 처리방침 변경)</h3>
                <p>① 이 개인정보처리방침은 2022년 3월 5부터 적용됩니다.</p>
              </article>

              <article>
                <h3> 타사 모듈 사용에 대한 안내</h3>
                <p>
                  탑재된 타사 서비스 모듈은 다음과 같습니다. <br />
                  1)Firebase/ Google Analytics
                  <br />
                  제공 회사：Google Inc
                  <br />
                  이용 목적：유저 유입 관리 및 마케팅 성과 측정, 품질 개선
                  <br />
                  제공 항목 : 개인 식별이 불가능한 휴대기기 식별자, 쿠키 및
                  유사한 기술 등을 통해 앱 사용자에 대한 데이터 등을 “Google”측
                  서버로 전송하게 됩니다. “Google”측의 개인정보 수집, 처리에
                  대한 정책은 해당 링크 내용을 확인하시기 바랍니다.
                  <br />
                  <a
                    href="http://www.google.com/policies/privacy/partners"
                    target="_blank"
                  >
                    http://www.google.com/policies/privacy/partners
                  </a>
                  <br />
                  “Google"은 위의 정보들을 토대로 서비스 어플리케이션 사용행태
                  정보를 비교 분석하여 회사에 제공하게 되고 회사는 서비스 품질
                  개선을 위해서만 해당 비교 분석 정보를 사용합니다. 동의하지
                  않는 이용자는 본 서비스를 사용하지 않을 수 있습니다.
                  <br />
                  <br />
                  2) Admob SDK
                  <br />
                  제공회사: GoogleInc <br />
                  이용목적: 광고 게재
                  <br />
                  제공 항목: 개인 식별이 불가능한 광고식별자
                </p>
              </article>
              <article>
                <h3> 개인정보 보호책임자 작성</h3>
                <p>
                  개인정보 처리방침에 대해 질문이 있다면, 아래 연락처로 연락해
                  주시길 바랍니다.
                  <br />
                  e-Mail :
                  <a href="mailto:vinieo0000@gmail.com" target="_blank">
                    vinieo0000@gmail.com
                  </a>
                </p>
              </article>
            </section>
          </div>
        </div>

        <footer>
          <div className="common_contents_inner">
            Copyright © Kemiez 2022 <br />
            e-Mail:{" "}
            <a href="mailto:vinieo0000@gmail.com" target="_blank">
              vinieo0000@gmail.com
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Policy;
